import Box from '@mui/material/Box';
import { Children, cloneElement, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    position?: 'center' | 'flex-end' | 'flex-start' | 'space-between' | 'end';
    direction?: 'column' | 'row';
}

const ButtonsBlock = ({ children, position = 'end', direction = 'row' }: Props) => (
    <Box
        data-cy='buttons-block'
        sx={{
            display: 'flex',
            gap: 2,
            justifyContent: position,
            flexWrap: 'wrap',
            flexDirection: direction,
        }}
    >
        {Children.map(children, (child: any, index: number) =>
            child ? <Box data-cy={`button-item-${index}`}>{cloneElement(child)}</Box> : null,
        )}
    </Box>
);

export default ButtonsBlock;
